/* eslint-disable jsx-a11y/no-distracting-elements */
import axios from "axios";
import { useEffect, useRef, useState } from "react";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Image from "react-bootstrap/Image";
import Row from "react-bootstrap/Row";
import Countdown from "react-countdown";
import { useLocation, useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import animaionImageHOme from "../../assets/2f53o.gif";
import OfferCountdown from "../Header/OfferCountdown";
import ProductCard from "../ProductCard";
import SkeletonLoader from "../SkeletonLoader";
import Spinner from "../Spinner/index";
import "./index.css";

const Home = () => {
  const navigate = useNavigate();
  const [categoryArray, setCategoryArray] = useState([]);
  const [productsArray, setProductsArray] = useState([]);
  const [isLoader, setIsLoader] = useState(true);
  const ref = useRef(null);

  const location = useLocation();
  useEffect(() => {
    if (ref?.current) {
      if (["STOPPED", "COMPLETED"].includes(ref?.current?.state?.status)) {
        ref?.current?.start();
      }
    }
  }, [location, ref]);
  const sliderImages = JSON.parse(process.env.REACT_APP_SLIDER || "[]");

  const cacheKey = "all_products";

  const getCategoryFromURL = () => {
    const params = new URLSearchParams(location.search);
    return params.get("category") || params.get("cat");
  };

  const fetchCategories = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/category/get`
      );
      if (res.data?.statusCode === 1 && res.data?.data?.length > 0) {
        return res.data.data;
      }
    } catch (error) {
      console.error("Error loading categories", error);
    }
    return [];
  };

  const fetchProductsByCategory = async (categoryId) => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/products/get?category=${categoryId}`
      );
      if (res.data?.statusCode === 1) {
        return res.data.data || [];
      }
    } catch (err) {
      console.error("Error fetching products for category:", categoryId, err);
    }
    return [];
  };

  const sortProductsByCategory = (data, categoryId) => {
    if (!categoryId || !Array.isArray(data)) return data;
    const index = data.findIndex((item) => item._id === categoryId);
    if (index === -1) return data;
    const reordered = [...data];
    const [selected] = reordered.splice(index, 1);
    return [selected, ...reordered];
  };

  const handleSequentialProductFetch = async () => {
    const finalCategoryId = getCategoryFromURL();
    setIsLoader(true);

    const categories = await fetchCategories();
    if (!categories?.length) {
      setProductsArray([]);
      setIsLoader(false);
      return;
    }

    const productGroup = await Promise.all(
      categories.map(async (cat) => {
        const products = await fetchProductsByCategory(cat._id);
        return {
          _id: cat._id,
          name: cat.name,
          products,
        };
      })
    );

    const sorted = sortProductsByCategory(productGroup, finalCategoryId);

    sessionStorage.setItem(
      cacheKey,
      JSON.stringify({
        products: sorted,
        timestamp: Date.now(),
      })
    );

    setProductsArray(sorted);
    setIsLoader(false);
  };

  useEffect(() => {
    const finalCategoryId = getCategoryFromURL();
    const cachedData = sessionStorage.getItem(cacheKey);

    if (cachedData) {
      const parsed = JSON.parse(cachedData);
      const age = Date.now() - parsed.timestamp;

      if (age < 5 * 60 * 1000) {
        const sorted = sortProductsByCategory(parsed.products, finalCategoryId);
        setProductsArray(sorted);
        setIsLoader(false);
        return;
      }
    }

    handleSequentialProductFetch();
  }, [location.search]);

  const settingSlick = {
    dots: false,
    infinite: sliderImages.length > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div className="category_block">
      <Container>
        {/* {categoryArray.length > 1 && (
          <Row
            className={
              "d-flex flex-row flex-wrap overflow-x-auto overflow-y-hidden category-box mb-2"
            }
          >
            {categoryArray.length > 0 &&
              categoryArray?.map((item) => (
                <Col xs={3} md={3}>
                  <Image
                    onClick={() => {
                      navigate(`/category/${item._id}`);
                    }}
                    src={item?.image || ""}
                    square
                    style={{
                      width: "100%",
                      height: "100%",
                      border: "1px solid black",
                    }}
                  />
                </Col>
              ))}
          </Row>
        )} */}

        <Row>
          <div className="ps-0 pe-0">
            <img
              src={animaionImageHOme}
              className="w-100"
              alt={window.location.hostname}
            />
          </div>
        </Row>

        <Row>
          {sliderImages.length > 0 && (
            <Col
              md={12}
              lg={12}
              xs={12}
              className="position-relative sliders_main ps-0 pe-0"
            >
              <Slider {...settingSlick}>
                {sliderImages?.map((image, index) => (
                  <div key={index} className="d-flex">
                    <img
                      src={image}
                      alt={`Knee ${index + 1}`}
                      className="w-full rounded-lg"
                      style={{ width: "100%", overflow: "hidden" }}
                    />
                  </div>
                ))}
              </Slider>

              <div
                style={{
                  position: "absolute",
                  bottom: "10px",
                  left: "12px",
                  right: "12px",
                }}
              ></div>
            </Col>
          )}
        </Row>

        {isLoader ? (
          <Spinner />
        ) : (
          <>
            <div
              className="menu"
              style={{
                backgroundColor: process.env.REACT_APP_THEAM_COLOR,
                margin: "0 -12px",
              }}
            >
              <marquee
                width="100%"
                direction="left"
                height="30px"
                fontWeight="700"
                style={{ color: "white" }}
              >
                <span>Buy 2 Get 1 Free (Add 3 item to cart)</span>
                <span>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span>
                <span>Buy 2 Get 1 Free (Add 3 item to cart)</span>
                <span>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span>
                <span>Buy 2 Get 1 Free (Add 3 item to cart)</span>
                <span>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span>
                <span>Buy 2 Get 1 Free (Add 3 item to cart)</span>
                <span>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span>
                <span>Buy 2 Get 1 Free (Add 3 item to cart)</span>
              </marquee>
            </div>

            {/* <div className="main-time">
              <div className="inner-time">
                <div className="dod-div">
                  <div className="dod-label">
                    Hurry Up !! <span className="big-sale-text">Big Sale</span>
                  </div>
                  <div
                    className="container p-3"
                    style={{ textAlign: "center", border: "none" }}
                  >
                    <span>
                      <Countdown
                        date={Date.now() + parseInt(500000)}
                        ref={ref}
                        renderer={(e) => <OfferCountdown />}
                        intervalDelay={1000}
                      />
                    </span>
                  </div>
                </div>
              </div>
            </div> */}
            <div className="p-1 font-serif 'container">
              {categoryArray.length > 1 && (
                <h3 className="text-2xl font-semibold mb-3  my-2">
                  SHOP BY CATEGORY
                </h3>
              )}
              <Row className="g-1">
                {categoryArray.length > 1 &&
                  categoryArray.map((item, index) => (
                    <Col
                      key={index}
                      xs={6}
                      onClick={() => navigate(`/category/${item?._id}`)}
                      className="cursor-pointer"
                    >
                      <div className="bg-white shadow rounded-lg p-2  d-flex gap-2  align-items-center justify-content-center">
                        <div>
                          <img
                            src={item?.image}
                            className="object-cover rounded"
                            width="45"
                            height="45"
                            alt={item?.name}
                          />
                        </div>
                        <div className=" font-medium text-sm text-truncate">
                          {item?.name}
                        </div>
                      </div>
                    </Col>
                  ))}
              </Row>
            </div>
            {isLoader ? (
              <Row xs={2} md={2} className="g-0 mt-2">
                <Col>
                  <SkeletonLoader />
                </Col>
                <Col>
                  <SkeletonLoader />
                </Col>
                <Col>
                  <SkeletonLoader />
                </Col>
                <Col>
                  <SkeletonLoader />
                </Col>
              </Row>
            ) : (
              productsArray?.map((item, index) => {
                return (
                  item?.products?.length > 0 && (
                    <div index={index}>
                      <h4 className="card-title text-center fw-bold my-3">{`${item.name}`}</h4>
                      <Row xs={2} md={2} className="g-0 mt-2">
                        {item.products.map((product, index) => (
                          <ProductCard item={product} index={index} />
                        ))}
                      </Row>
                      <Button
                        className="btn my-3 d-flex justify-content-center align-items-center ripple animated"
                        style={{
                          fontWeight: 600,
                          fontSize: "18px",
                          margin: "auto",
                          borderWidth: "2px",
                          padding: "10px 20px",
                          borderColor: "var(--them-color)",
                          color: "var(--them-color)",
                          background: "#ffff",
                        }}
                        onClick={(e) => {
                          e?.target?.classList?.add("bounceIn");
                          navigate(`/category/${item._id}`);
                          setTimeout(() => {
                            if (e?.target?.classList?.contains("bounceIn"))
                              e?.target?.classList?.remove("bounceIn");
                          }, 1000);
                        }}
                      >
                        View More
                      </Button>
                    </div>
                  )
                );
              })
            )}
          </>
        )}
      </Container>
    </div>
  );
};

export default Home;
